export default __webpack_public_path__ + "static/media/Logos.2f0a7459.png";